export const formatThousandsComma = (value: number | string | bigint) => {
    if (value === null || value === undefined) return '';

    // 문자열이면 공백/콤마/언더스코어 제거
    let s = typeof value === 'bigint' ? value.toString() : String(value);
    s = s.replace(/[\s,_]/g, '');

    // 부호 분리
    const isNeg = s.startsWith('-');
    if (isNeg) s = s.slice(1);

    // 소수점 분리
    const [intPartRaw, decPart] = s.split('.');

    // 정수부만 콤마
    const intPart = intPartRaw.replace(/\D/g, ''); // 숫자만 보존
    const intWithCommas = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    const result = (isNeg ? '-' : '') + intWithCommas + (decPart ? '.' + decPart : '');
    return result;
};
